// redux/selectors/mainSelectors.ts
import { RootState } from "../../storeTypes";
import {
  TermsAndPolicy,
  Prayer,
  VideoCategory,
  VideoSeries,
  OfficialVideo,
} from "../../../types/main/mainTypes";
import { buildStaticChoiceKey } from "@/redux/main/mainSlice";

// Get a specific static choice by name ---------------------------------------
export const selectStaticChoice = (choiceName: string) => (state: RootState) =>
  state.main.staticChoices[choiceName] || [];

export const selectStaticChoiceByParams =
  (choiceName: string, params?: Record<string, any>) => (state: any) => {
    const key = buildStaticChoiceKey(choiceName, params);
    return state.main.staticChoices[key] || [];
  };

export const selectStaticChoiceStatus =
  (choiceName: string, params?: Record<string, any>) => (state: any) => {
    const key = buildStaticChoiceKey(choiceName, params);
    return state.main.staticChoices[key] ? "succeeded" : "idle";
  };

export const selectChoiceAsObjects =
  (choiceName: string) => (state: RootState) =>
    (state.main.staticChoices[choiceName] || []).map(
      ([value, label]: [string, string]) => ({ value, label }),
    );

// Get all terms and policies ------------------------------------------------
export const selectTermsAndPolicies = (state: RootState): TermsAndPolicy[] =>
  state.main.termsAndPolicies ?? [];

// Get loading status for various main actions
export const selectMainLoading = (state: RootState) => state.main.loading;

// Get global error message from main slice
export const selectMainError = (state: RootState) => state.main.error;

// Get success message (e.g., after submitting feedback)
export const selectMainSuccessMessage = (state: RootState) =>
  state.main.successMessage;

// ------------------- Official Videos Section -------------------
export const selectVideoCategories = (state: RootState): VideoCategory[] =>
  state.main.videoCategories ?? [];

export const selectVideoSeries = (state: RootState): VideoSeries[] =>
  state.main.videoSeries ?? [];

export const selectOfficialVideos = (state: RootState): OfficialVideo[] =>
  state.main.officialVideos ?? [];

export const selectSearchResults = (state: RootState) =>
  state.main.searchResults;
export const selectSearchLoading = (state: RootState) =>
  state.main.searchLoading;
export const selectSearchError = (state: RootState) => state.main.searchError;

// ------------------- Public Prayers Section -------------------
// --- Get list of public prayers (for display) ---
export const selectPublicPrayers = (state: RootState): Prayer[] =>
  state.main.publicPrayers;

// --- Get total number of public prayers ---
export const selectPrayerCount = (state: RootState): number =>
  state.main.prayerCount;

// --- Get current page for public prayers (for Load More) ---
export const selectPrayerPage = (state: RootState): number =>
  state.main.prayerPage;

// --- Get loading status for prayer-related actions ---
export const selectPrayerLoading = (state: RootState) => ({
  fetch: state.main.loading.fetchPrayers,
  submit: state.main.loading.submitPrayer,
});

export const selectTotalPrayerCount = (state: RootState) =>
  state.main.totalPrayerCount;
